import React, { useEffect, useState, useRef } from 'react'
import { InputBox, FormButton, Switch, SelectInputBox } from "../commoncomponents/InputBox";
import { useAuth } from '../../context/auth';
import { Table } from '../commoncomponents/Table';
//loder
import BlurLoader from "../Loder/BlurLoader";
//react toast 
import { toast } from 'react-toastify';
//common Data
import { API_SERVER, handleDownloadExcel, initializeFilterData } from '../../Utils';
//services
import { post } from '../../apiservices/service';
import { number, numberwithDot, Token } from '../Common/Common';

function AllowanceMaster() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();
    const TokenData =Token()

    //initial state
    const [recipe, setRecipe] = useState({
        AllowanceID:"0",
        AllowanceName: "", AllowanceDisName: "", SequenceNo: "", Active: true, DeductESI: false, DeductPF: false, Rembursement: false
        , LeaveEncash: false, OT: false, Gross: true, CalculationType: "", Taxable:false,
    })
    const [result, setResult] = useState({});
    const [loading, setLoading] = useState(false)
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData);
    const [isUpdate, setIsUpdate] = useState(false);
    const [errors, setErrors] = useState({});

    const getFormData = (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }

        setLoading(true)

        let temp = {
            PageIndex: PageIndex.toString(),
            SearchText: "",
            StartValue: "1",
            SearchFieldValue: "",
            Type: "s"
        }
        post(`${API_SERVER}api/MASTER/ShowAllowanceMaster`, { ...TokenData, ...temp, ...sortConfig, ...filterData }, (res) => {
            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    setLoading(false)
                    setResult({ ...res })
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    setResult({ ...res })
                }
            }
        });
    }

    const handleChange1 = (event, value) => {
          getFormData(value);
    };

    useEffect(() => {
        inputrefs.current['txtAllowanceName'].focus();
        document.title = 'Viva HRMS : Allowance Master'
        getFormData()
    }, [sortConfig, isUpdate])

    //Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    //validation handler
    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            { field: "AllowanceName", msg: 'Please Enter Allowance Name.' },
            { field: "AllowanceDisName", msg: 'Please Enter Allowance Display Name.' },
            { field: "SequenceNo", msg: 'Please Enter Sequence No.' },
            { field: "CalculationType", msg: 'Please Select Calculation Type.' },
            { field: "CalculationPercent", msg: 'Please Enter Calculation Percent.' },
        ]

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0 || recipe[item.field] === '') {
                
                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });

        return isValid;
    }

    //Submit Handler
    const handleSubmit = () => {
        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/MASTER/InsertUpdateAllowanceMaster`, { ...TokenData, ...recipe }, (res) => {
                if (res && res.status) {
                    if (res.status === "ERROR") {
                        toast.error(res.message)
                        inputrefs.current[res.focus].focus();
                        setLoading(false)
                    } else if (res.Status === "EXPIRED") {
                        toast.error(res.Message)
                        sessionExpired()
                    } else if (res.Status === "UNAUTHORIZED") {
                        toast.error(res.Message);
                        setLoading(false);
                    } else {
                        setLoading(false)
                        toast.success(res.message)
                        getFormData()
                        handleClear()
                    }
                }
            });
        }
        else {
        }
    }

    //Handle Edit
    const handleEdit = (Id) => {
        setLoading(true)
        post(`${API_SERVER}api/MASTER/EditAllowanceMaster`, { ...TokenData, AllowanceID: Id }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    let data = res.data
                    setRecipe({
                        ...data, AllowanceName: data.allowanceName
                        , AllowanceDisName: data.allowanceDisName
                        , Active: data.active
                        , SequenceNo: data.sequenceNo, DeductESI: data.deductESI, DeductPF: data.deductPF, Rembursement: data.rembursement
                        , LeaveEncash: data.leaveEncash, OT: data.ot, Gross: data.gross, CalculationType: data.calculationType, CalculationPercent: data.calculationPercent, Taxable: data.taxable,
                    })
                }
            }
        });
    }

    //Handle Delete
    const handleDelete = (Id) => {
        setLoading(true)
        post(`${API_SERVER}api/MASTER/DeleteAllowanceMaster`, { ...TokenData, AllowanceID: Id }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    toast.success(res.message)
                    setLoading(false)
                    getFormData()
                    handleClear()
                }
            }
        });
    }

    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({
            ...recipe, AllowanceID:"0",
            AllowanceName: "", AllowanceDisName: "", SequenceNo: "", Active: true, DeductESI: false, DeductPF: false, Rembursement: false, LeaveEncash: false, OT: false, Gross: true, CalculationType: "", CalculationPercent: "", Taxable: false,
        }))
        setErrors({})
        setFilterData(filterData => ({ ...filterData, SearchText: '' }))
        setIsUpdate(!isUpdate)
        getFormData()
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    //Start Export functionality
    let ExportRequest = {
        ...filterData,
        ...TokenData,
        ...sortConfig,
        Type: 'E',
        PageIndex: '1'
    }
    //End Export functionality

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">Allowance Master</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <InputBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtAllowanceDisName'].focus() };
                            }}
                            label='Allowance Name'
                            id='txtAllowanceName'
                            maxLength='50'
                            placeholder="Allowance Name"
                            value={recipe.AllowanceName}
                            error={errors.AllowanceName}
                            onChange={(e) => HandleChange('AllowanceName', e.target.value)}
                            required
                        />

                        <InputBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtSequenceNo'].focus() };
                            }}
                            label='Allowance Display Name'
                            id='txtAllowanceDisName'
                            maxLength='50'
                            placeholder="Allowance Display Name"
                            value={recipe.AllowanceDisName}
                            error={errors.AllowanceDisName}
                            onChange={(e) => HandleChange('AllowanceDisName', e.target.value)}
                            required
                        />
                        <InputBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtCalculationType'].focus() };
                            }}
                            label='Sequence No.'
                            id='txtSequenceNo'
                            maxLength='2'
                            placeholder="Sequence No."
                            value={recipe.SequenceNo}
                            error={errors.SequenceNo}
                            onChange={(e) => { HandleChange('SequenceNo', number(e.target.value)) }}
                            required
                        />

                        <SelectInputBox
                            label='Calculation Type'
                            inputrefs={inputrefs}
                            required
                            id="txtCalculationType"
                            value={recipe.CalculationType}
                            error={errors.CalculationType}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtCalculationPercent'].focus() };
                            }}
                            onChange={(e) => HandleChange('CalculationType', e.target.value)}
                            children={<>
                                <option value="">--Select Calculation Type--</option>
                                <option value="On Attendance" >On Attendance</option>
                                <option value="Monthly" >Monthly</option>
                                <option value="Per Day">Per Day</option>
                            </>}
                        />
                        <InputBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtIsActive'].focus() };
                            }}
                            label='Calculation Percent'
                            id='txtCalculationPercent'
                            maxLength='6'
                            placeholder="Calculation Percent"
                            value={recipe.CalculationPercent}
                            error={errors.CalculationPercent}
                            onChange={(e) => {
                                HandleChange('CalculationPercent', numberwithDot(e.target.value))}
                            }
                            onKeyUp={(e) => {
                                if (e.target.value > 100) { HandleChange('CalculationPercent', '') };
                            }}
                            required
                        />
                        <Switch
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDeductPF'].focus() };
                            }}
                            label='Active'
                            checked={recipe.Active}
                            id='txtIsActive'
                            nextinputid='txtFranchiseGroup'
                            onChange={(e) => HandleChange('Active', e.target.checked)}
                        />
                        <Switch
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDeductESI'].focus() };
                            }}
                            label='Deduct PF'
                            checked={recipe.DeductPF}
                            id='txtDeductPF'
                            nextinputid='txtFranchiseGroup'
                            onChange={(e) => HandleChange('DeductPF', e.target.checked)}
                        />
                        <Switch
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtRembursement'].focus() };
                            }}
                            label='Deduct ESI'
                            checked={recipe.DeductESI}
                            id='txtDeductESI'
                            nextinputid='txtFranchiseGroup'
                            onChange={(e) => HandleChange('DeductESI', e.target.checked)}
                        />
                        <Switch
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtLeaveEncash'].focus() };
                            }}
                            label='Reimbursement'
                            checked={recipe.Rembursement}
                            id='txtRembursement'
                            nextinputid='txtFranchiseGroup'
                            onChange={(e) => HandleChange('Rembursement', e.target.checked)}
                        />
                        <Switch
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtOT'].focus() };
                            }}
                            label='Leave Encash'
                            checked={recipe.LeaveEncash}
                            id='txtLeaveEncash'
                            nextinputid='txtFranchiseGroup'
                            onChange={(e) => HandleChange('LeaveEncash', e.target.checked)}
                        />
                        <Switch
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtGross'].focus() };
                            }}
                            label='OT'
                            checked={recipe.OT}
                            id='txtOT'
                            nextinputid='txtFranchiseGroup'
                            onChange={(e) => HandleChange('OT', e.target.checked)}
                        />
                        <Switch
                            inputrefs={inputrefs}
                            label='Gross'
                            checked={recipe.Gross}
                            id='txtGross'
                            nextinputid='txtFranchiseGroup'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtTaxable'].focus() };
                            }}
                            onChange={(e) => HandleChange('Gross', e.target.checked)}
                        />
                        <Switch
                            inputrefs={inputrefs}
                            label='Taxable'
                            checked={recipe.Taxable}
                            id='txtTaxable'
                            //nextinputid='txtFranchiseGroup'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { handleSubmit() };
                            }}
                            onChange={(e) => HandleChange('Taxable', e.target.checked)}
                        />


                        <FormButton
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(API_SERVER + 'api/MASTER/ShowAllowanceMaster', ExportRequest, 'Allowance Master')}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>          

            <Table
                Token={TokenData}
                PageName='AllowanceMaster'
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handleFilter={() => {
                    getFormData();
                    setFilterData({
                        ...filterData,
                    });
                }}
                tableData={result}
                //  loading={loading}
                filterData={filterData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />

            {/* Loder start*/}
            {loading && < BlurLoader />}
            {/* Loder End*/}
        </>
    )
}

export default AllowanceMaster
